import './ComponentsPanel.scss';

import ComponentsPanel from './ComponentsPanel';
import getComponentsPanelSchema from './schemas/componentsPanelSchema';

export { ComponentsPanel, getComponentsPanelSchema };
